import React, { type JSX } from 'react';
import Grid from '@mui/material/Grid';
import { SPACING_BETWEEN_FORM_FIELDS } from './spacings';
import { formatDDMMYYYY } from '../../shared/dateTime';
import { Person } from '../../types';
import { anredeAuswahl } from '../../frontendConstants';
type Props = {
  readonly person: Person;
  readonly testPraefix: string;
};

export default function PersonAnzeige({ person, testPraefix }: Props): JSX.Element {
  return (
    <Grid container data-testid={`${testPraefix}-anzeige`}>
      <Grid size={{ xs: 12, sm: 6 }} container>
        {person?.anrede === 'FIRMA' && (
          <>
            <Grid size={6}>Firmenname:</Grid>
            <Grid size={6}>{person?.firmenname ?? ''}</Grid>
          </>
        )}
        <Grid size={12}>{anredeAuswahl.find((anrede) => anrede.value === person?.anrede)?.label ?? ''}</Grid>
        <Grid size={12}>
          {person?.vorname ?? ''} {person?.nachname ?? ''}
        </Grid>
        <Grid size={12}>
          {person?.strasse ?? ''} {person?.plz ?? ''} {person?.ort ?? ''}
        </Grid>
        <Grid size={12}>{formatDDMMYYYY(person?.geburtsdatum)}</Grid>
        <Grid size={12}>{person?.nationalitaet ?? ''}</Grid>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} container spacing={SPACING_BETWEEN_FORM_FIELDS}>
        <Grid size={12}>Tel.: {person?.telefon?.join(', ') ?? ''}</Grid>
        <Grid size={12}>E-Mail: {person?.email?.join(', ') ?? ''}</Grid>
      </Grid>
    </Grid>
  );
}
